module.exports = __webpack_public_path__ + "img/loading.eda1d1c3.svg";